import { useEffect, useState } from "react"
import { Box, Chip, Grid, IconButton, Typography, useTheme } from "@mui/material"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonBasic, TableBase } from "../../components"
import { showModal } from "react-redux-modal-provider";
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import ConfirmationDialog from "../../modals/default/ConfirmationDialog";
import ProcesosService from "../../services/procesos.service";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ModalProcesos from "../../modals/procesos/ModalProcesos";
import { useNavigate } from "react-router-dom";

const TablaProcesosScreen = () => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [items, setItems] = useState([]);
    const navigate = useNavigate()
    const actualizar = async() =>{
        await ProcesosService.getAll({type: 'all'}).then((resp)=>{
            setItems(resp)
        })
    }

    const columns = [
        {
            name: "id_pro",
            label: "ID",
            options: {
                filter: false,
                sort: false,
                display:false,
                viewColumns: false
            }
        },
        {
            name: "nombre_pro",
            label: "Nombre",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: 'isDeleted_pro',
            label: "Estado",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if(!value){
                    return <Chip label="Activo" color="success" />
                    }
                    return <Chip label="Inactivo" color="error" />
                }
            }
        },
        {
            name: 'actions',
            label: "Acciones",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => (
                    <>
                        <Box display='flex'>
                            <IconButton color='info' aria-label="edit" onClick={()=>onRedirect(tableMeta.rowData[0])}>
                                <RemoveRedEyeIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                            <IconButton color='info' aria-label="edit" onClick={()=>onOpenEditar(tableMeta.rowData[0])}>
                                <EditIcon fontSize="medium" sx={{color: isDarkMode ? '#90caf9' : '#0364ff'}} />
                            </IconButton>
                            <IconButton color='info' aria-label="edit" onClick={()=>onEliminar(tableMeta.rowData[0])}>
                                { !tableMeta.rowData[2] ?(
                                    <DeleteIcon fontSize="medium" sx={{color: isDarkMode ? '#f87171' : '#e01010'}} />
                                ):(
                                    <PublishedWithChangesIcon fontSize="medium" sx={{color: isDarkMode ? '#4ade80' : '#018155'}} />
                                )}
                            </IconButton>
                        </Box>
                    </>
                )
            }
        }
    ];
    const onGuardar = () => actualizar();
    const onRedirect = (id) =>{
        navigate(`/procesos/${id}`)
    }

    const onOpenEditar = (item) => {
        if(item){
            const searchItem = items.find((sItem)=> sItem.id_pro === item)
            showModal(ModalProcesos, {item: searchItem, onGuardar: onGuardar});
        }else{
            showModal(ModalProcesos, {onGuardar: onGuardar});
        }
    };
    const onEliminar = (item) => {
        const searchItem = items.find((sItem)=> sItem.id_pro === item)
        showModal(ConfirmationDialog, {
            title: `${searchItem?.isDeleted_pro ? 'Activar' : 'Eliminar'} el proceso`,
            message: `¿Esta seguro que desea ${searchItem?.isDeleted_pro ? 'activar' : 'eliminar'} el proceso?`,
            onConfirm: () => {
                ProcesosService.destroy(searchItem.id_pro).then(() => {
                    onGuardar();
                });
            }
        });
    };
    useEffect(() => {
        actualizar();
        document.title = `Procesos`;
    }, [])

    return (
        <Box sx={{width:'100%',height: '100%',overflow:'auto', background: isDarkMode ? '#1a2332' : '#f5f5f5'}} className='side'>
            <Grid container p={3} display='flex' justifyContent='center'>
                <Grid item xs={6}>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000', fontWeight: 'bold'}} variant="h2">Tabla Procesos</Typography>
                </Grid>
                <Grid item xs={6} sx={{display: 'flex', justifyContent: 'end'}}>
                    <ButtonBasic
                        textButton="NUEVO"
                        sx={{width: 200, height: 30}}
                        onClick={()=>onOpenEditar()}
                        variant='wk'
                        color="nextStep"
                    />
                </Grid>
                <Grid item xs={12} md={6} mt={2} sx={{marginBottom: 15}}>
                    <TableBase title='Resultados' columns={columns} data={items} />
                </Grid>
            </Grid>
        </Box>
    )
}

export default TablaProcesosScreen